// The Scheduling section is kept exactly as it was (owner's decision, 2026-09-24). Its pages keep
// their original page frame, page-entry animation and top-bar titles.
export const SCHEDULING_ROUTES = ['/scheduler', '/templates', '/groups', '/sil', '/job-board', '/live-tracking', '/worker-activity', '/evv'];

export const isSchedulingRoute = (pathname) =>
  SCHEDULING_ROUTES.some((p) => pathname === p || pathname.startsWith(p + '/'));

// Sections whose wide tables scroll inside their own container. On these, <main> clips sideways
// instead of scrolling, which is what lets sticky headers, toolbars and save bars actually stick.
// A section is added here once its tables have their own scroll area, so nothing that used to be
// reachable by scrolling the page sideways gets cut off.
export const STICKY_READY = [
  '/settings', '/clients',
  // Care modules, reports & settings
  '/aged-care', '/support-coordination', '/plan-management',
  // Staff & HR
  '/staff', '/teams', '/leave', '/reimbursements', '/payslips',
  // Time, pay & finance
  '/timesheets', '/invoices', '/financials', '/billing', '/mileage',
  // Care delivery & tools
  '/medications', '/forms', '/incidents', '/tasks', '/service-agreements', '/messages', '/vehicles',
  '/automations', '/activity', '/ai-receptionist', '/receptionist', '/chatbot', '/migration', '/facilities',
];

export const isStickyReady = (pathname) =>
  STICKY_READY.some((p) => pathname === p || pathname.startsWith(p + '/'));

// ─── Section colours ─────────────────────────────────────────────────────────
// Each area of the app carries one hue, chosen for what that work means to the people doing it,
// so you can tell where you are at a glance (sidebar section, top-bar badge, card and tile icons).
// Actions and selection stay the brand indigo everywhere; green / amber / red stay reserved for
// state (paid, due, overdue). The hues are CSS variables (.hue-* in index.css).
//   indigo  Dashboard             trust and focus: the brand
//   blue    Scheduling            dependable, on time
//   orange  People                warm, friendly, human
//   pink    Care & quality        compassion and wellbeing
//   teal    Aged care             calm, health, reassurance (its established colour)
//   violet  Support coordination  guidance and wisdom
//   sky     Plan management       clarity and trust with a participant's money
//   emerald Finance & payroll     money, growth, stability
//   amber   Insights              optimism, seeing clearly
//   cyan    Communications        openness, conversation
//   slate   Admin & platform      neutral, in control
export const SECTION_HUE = {
  Scheduling: 'blue', People: 'orange', 'Care & Quality': 'pink', 'Aged Care': 'teal',
  'Support Coordination': 'violet', 'Plan Management': 'sky', 'Finance & Payroll': 'emerald',
  Insights: 'amber', Communications: 'cyan', Platform: 'slate', Admin: 'slate',
};

const HUE_BY_PATH = [
  ['blue', SCHEDULING_ROUTES],
  ['orange', ['/clients', '/staff', '/teams', '/leave']],
  ['pink', ['/medications', '/forms', '/tasks', '/incidents', '/service-agreements']],
  ['teal', ['/aged-care']],
  ['violet', ['/support-coordination']],
  ['sky', ['/plan-management']],
  ['emerald', ['/invoices', '/timesheets', '/payslips', '/financials', '/reimbursements', '/mileage', '/billing']],
  ['amber', ['/reports', '/automations', '/market-intel']],
  ['cyan', ['/messages', '/receptionist', '/ai-receptionist', '/chatbot']],
  ['slate', ['/settings', '/vehicles', '/facilities', '/activity', '/migration', '/export-data', '/compliance', '/superadmin', '/website']],
];

export const hueFor = (pathname) => {
  if (pathname === '/') return 'indigo';
  const hit = HUE_BY_PATH.find(([, paths]) => paths.some((p) => pathname === p || pathname.startsWith(p + '/')));
  return hit ? hit[0] : 'indigo';
};
